import {Navigate, Outlet} from 'react-router-dom'
import {useContext} from "react";
import AuthContext from "../context/AuthContext";

export default function PrivateRoutes() {
    // console.log('Private Route')
    // let auth = {'token': true}
    let {user} = useContext(AuthContext)

    return (
        user ? <Outlet/> : <Navigate to='/login' />
    )
}